import { useTranslation } from 'react-i18next';

const darkFeatures = [
  { icon: 'ri-file-list-3-line', key: 'dark.feature1' },
  { icon: 'ri-search-line', key: 'dark.feature2' },
  { icon: 'ri-coupon-line', key: 'dark.feature3' },
  { icon: 'ri-shield-check-line', key: 'dark.feature4' },
  { icon: 'ri-ship-line', key: 'dark.feature5' },
];

export default function DarkCTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-foreground-950">
      <div className="max-w-5xl mx-auto text-center">
        <span className="inline-block text-xs tracking-[0.2em] uppercase text-foreground-300 font-semibold mb-5">
          {t('dark.label')}
        </span>

        <h2 className="text-3xl md:text-6xl font-heading font-bold text-white leading-tight mb-8">
          {t('dark.title1')}
          <br />
          {t('dark.title2')}
          <br />
          {t('dark.title3')}
        </h2>

        <div className="flex flex-col sm:flex-row gap-3 justify-center mb-14">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center justify-center px-8 py-3.5 bg-white text-foreground-950 text-sm font-semibold rounded-md hover:bg-background-100 transition-colors cursor-pointer"
          >
            {t('dark.cta_access')}
            <i className="ri-arrow-right-up-line ml-2 w-4 h-4 flex items-center justify-center"></i>
          </a>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center justify-center px-8 py-3.5 border-2 border-white/30 text-white text-sm font-semibold rounded-md hover:border-white/60 transition-colors cursor-pointer"
          >
            {t('dark.cta_compare')}
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
          {darkFeatures.map((feat, i) => (
            <div
              key={i}
              className="bg-foreground-900/50 rounded-2xl p-5 flex flex-col items-center gap-3"
            >
              <div className="w-10 h-10 rounded-xl bg-foreground-800 flex items-center justify-center">
                <i className={`${feat.icon} w-5 h-5 flex items-center justify-center text-white/70`}></i>
              </div>
              <span className="text-xs text-white/70 font-medium whitespace-nowrap">{t(feat.key)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}